import Api, { make, Response } from 'src/services/api'
import { AssignTree, Id, PolicyTree } from 'src/types'

type Data = {
  policy_trees: PolicyTree[]
  total_results: number
}

type GetAllProps = {
  organization_id: Id
  page: number
  withInactive?: boolean
}

type SaveProps = {
  assign_tree_id: Id
  organization_id: Id
  policy_id: Id
  policy: string
}

export const PAGE_SIZE = 10

export function getAll({
  organization_id,
  page,
  withInactive = false
}: GetAllProps): Promise<Response<Data>> {
  return make<Data>({
    axiosCall: Api.get(
      `organizations/${organization_id}/policy_trees?page_size=${PAGE_SIZE}&page=${page || 1
      }${withInactive ? '&active=True' : ''}`
    )
  })
}

export function save({
  organization_id,
  assign_tree_id,
  policy,
  policy_id
}: SaveProps): Promise<Response<PolicyTree>> {
  return make<PolicyTree>({
    axiosCall: Api.post(`organizations/${organization_id}/policy_trees`, {
      policy_trees: [{
        assign_tree_id,
        [policy]: policy_id
      }]
    })
  })
}

type GetChainsProps = {
  assign_tree_id: Id
  policy_name: 'approval' | 'conference'
}

export type ChainsProps = {
  assign_tree_id: Id
  chained_assign_tree_id: Id
  chained_assign_tree_name: string
}

export function getChains({
  assign_tree_id,
  policy_name
}: GetChainsProps): Promise<Response<ChainsProps[]>> {
  const policyName = policy_name === 'approval' ? 'approval_chain_trees' : 'conference_chain_trees'
  return make<ChainsProps[] | any>({
    axiosCall: Api.get(`trees/${assign_tree_id}/${policy_name}/chain`),
    transformData: data => data[policyName]
  })
}

type updateChainedProps = {
  assign_tree_id: Id
  chained: boolean
  p_assign_tree_type: string
  assign_tree_name: string
  organization_id: Id
}

export function updateChained({
  assign_tree_id,
  chained,
  p_assign_tree_type,
  assign_tree_name,
  organization_id
}: updateChainedProps): Promise<Response<AssignTree[]>> {
  return make<AssignTree[] | any>({
    axiosCall: Api.post('trees', {
      trees: [{
        assign_tree_id,
        chained,
        p_assign_tree_type,
        assign_tree_name,
        organization_id
      }]
    }),
    transformData: data => data.trees
  })
}

type ChainedProps = {
  assign_tree_id: Id
  policy_name: 'approval' | 'conference'
  chained_assign_tree_id: Id
  method: 'remove' | 'save'
}

export function saveChained({
  assign_tree_id,
  policy_name,
  chained_assign_tree_id,
  method
}: ChainedProps): Promise<Response<AssignTree[]>>{
  const policyName = policy_name === 'approval' ? 'approval_chain_tree' : 'conference_chain_tree'
  const body = {
    chained_assign_tree_id,
    remove: true
  }
  if (method === 'save') {
    delete body.remove
  }
  return make<AssignTree[]>({
    axiosCall: Api.post(`/trees/${assign_tree_id}/${policy_name}/chain`, {
      [policyName]: body
    })
  })
}